import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import {
  DateRangeRounded,
  PersonRounded as PersonIcon,
  Room as RoomIcon,
  SchoolRounded as SchoolIcon,
} from '@material-ui/icons';
import { getInfosDashboard, getTrainingById } from '@webapps/business';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

const InfoName = ({ info }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { data: images = {} } = useQuery(getInfosDashboard, {
    key: ['imageProfile', info?.classroom?.school?.id],
    variables: { id: info?.classroom?.school?.id },
    enabled: typeof info?.classroom?.school?.id !== 'undefined',
  });

  const { data: training = {} } = useQuery(getTrainingById, {
    key: ['training', info?.classroom?.training],
    variables: { id: info?.classroom?.training },
    enabled: typeof info?.classroom?.training !== 'undefined',
  });

  return (
    <div className={classes.container}>
      <Grid container item>
        <Grid item xs>
          <Card style={{ position: 'relative', borderRadius: '0' }} elevation={0}>
            <CardMedia
              component="img"
              alt={`Image de couverture de ${info?.classroom?.school?.name}`}
              height={'178'}
              image={images?.profile?.coverImageUrl}
              title={`Image de couverture de ${info?.classroom?.school?.name}`}
              style={{ position: 'relative' }}
            />
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(5, 6, 50, 0.85)',
              }}
            />
            <div
              className={cx(
                classes.divInfos,
                css({
                  position: 'absolute',
                  top: 0,
                  padding: '24px',
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                })
              )}
            >
              <AvatarCompany
                width={130}
                height={130}
                idCompany={info?.classroom?.school?.id}
              />
              <div className={classes.nameContainer}>
                <div className={cx(global.infoText, classes.name)}>
                  <div style={{ marginRight: 5 }}>{info?.classroom?.school?.name}</div>
                  <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
                </div>
                <div className={cx(global.title, classes.training)}>
                  {training?.label}
                </div>
                <div className={classes.infoContainer}>
                  <div className={cx(global.infoText, classes.address)}>
                    <RoomIcon className={global.infoIcon} />
                    <div>
                      {info?.classroom?.school?.address?.city} {info?.classroom?.school?.address?.cityCode}{' '}
                    </div>
                  </div>
                  <div className={cx(global.infoText, classes.address)}>
                    <SchoolIcon className={global.infoIcon} />
                    <div>
                      {training?.degree?.label}
                    </div>
                  </div>
                  <div className={cx(global.infoText, classes.address)}>
                    <PersonIcon className={global.infoIcon} />
                    <div>
                      {`${info?.students.length} ${info?.students.length === 1 ? 'apprenant' : 'apprenants'}`}
                    </div>
                  </div>
                  <div className={cx(global.infoText, classes.address)}>
                    <DateRangeRounded className={global.infoIcon} />
                    <div>
                      <FormattedDate
                        day="numeric"
                        month="numeric"
                        value={info?.classroom?.startDate}
                        year="numeric"
                      />
                      {' '} au {' '}
                      <FormattedDate
                        day="numeric"
                        month="numeric"
                        value={info?.classroom?.endDate}
                        year="numeric"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

const styles = ({ spacing }) => ({
  customfavorite: {
    color: '#5A6DA1',
    background: '#000000 !important',
    minWidth: '231px',
  },
  btnsContainer: {
    zIndex: 1,
    display: 'flex',
  },
  infoContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  btnaddfavoris: {
    marginLeft: 16,
  },
  btnVitrine: {
    color: '#5A6DA1',
    backgroundColor: '#F3F7FF',
    minWidth: '231px',
    marginLeft: 16,
  },
  containerInfo: {
    padding: spacing(2.5, 2.5, 0, 2.5),
    display: 'flex',
    alignContent: 'center',
  },
  divImage: {
    backgroundColor: '#5A6DA1',
    height: '23vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  nameContainer: {
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: 20,
  },
  divInfos: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  name: {
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 5,
  },
  training: {
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
  },
  address: {
    marginTop: 5,
    marginBottom: 5,
    fontWeight: 'regular',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    color: '#FFFFFF',
    marginRight: 15,
  },
  gridBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  mobileOnly: {
    position: 'absolute',
    color: '#fff',
    right: 0,
    top: 0,
    border: 'none',
  },
});

InfoName.propTypes = {
  info: PropTypes.object,
};

export default InfoName;
